import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getDiagnosticPage = createAsyncThunk('diagnosticPage/getDiagnosticPage', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getDiagnosticPage();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
export const getDiagnosticPageStaff = createAsyncThunk('diagnosticPage/getDiagnosticPageStaff', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getStaff();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
